import { React, useState, useEffect } from "react";

const PopUpCentercardResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;

    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    let centerCardMarkets = [];
    let centerCardWinners = [];

    if (marketType == 45) {

        centerCardMarkets = [
            "Center-Yes",
            "Center-No",

            "Center-Even",
            "Center-Odd",

            "Left-Even",
            "Left-Odd",

            "Right-Even",
            "Right-Odd",

            "Center Red",
            "Center Black",

            "Left Red",
            "Left Black",

            "Right Red",
            "Right Black",
        ];

        centerCardWinners =
            typeof resultData?.resultTxt === "string"
                ? resultData.resultTxt.split(",").map(item => item.trim())
                : [];

    }

    return (
      <div>
        <div id="ResultsData">
          <div class="left-content site_family">
            <div
              id="center-card"
              style={{ display: marketType == 45 ? "" : "none" }}
            >
              <div className="left-content">
                <div className="card">
                  <div className="card-header">
                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                  </div>
                  <div className="card-body">
                    <div className="player-item">
                      <b>
                        <span className="name" style={{ color: "#000" }}>
                          Left
                        </span>
                      </b>
                      <div className="player-card">
                        <div className="BFBCardHandViewDealerab">
                          <div
                            className="BFBCardFanViewab"
                            style={{
                              justifyContent: "center",
                              padding: "3px"
                            }}
                          >
                            <div className="RSMImageView2ab">
                              <img
                                src={`/assets/images/cards/${resultData.c1}.svg`}
                                style={{
                                  width: "100%",
                                  maxWidth: "45px",
                                  height: "auto"
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="player-item">
                      <b>
                        <span className="name" style={{ color: "#000" }}>
                          Center
                        </span>
                      </b>
                      <div className="player-card">
                        <div className="BFBCardHandViewDealerab">
                          <div
                            className="BFBCardFanViewab"
                            style={{
                              justifyContent: "center",
                              padding: "3px"
                            }}
                          >
                            <div className="RSMImageView2ab">
                              <img
                                src={`/assets/images/cards/${resultData.c3}.svg`}
                                style={{
                                  width: "100%",
                                  maxWidth: "45px",
                                  height: "auto"
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="player-item">
                      <b>
                        <span className="name" style={{ color: "#000" }}>
                          Right
                        </span>
                      </b>
                      <div className="player-card">
                        <div className="BFBCardHandViewDealerab">
                          <div
                            className="BFBCardFanViewab"
                            style={{
                              justifyContent: "center",
                              padding: "3px"
                            }}
                          >
                            <div className="RSMImageView2ab">
                              <img
                                src={`/assets/images/cards/${resultData.c2}.svg`}
                                style={{
                                  width: "100%",
                                  maxWidth: "45px",
                                  height: "auto"
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={{ marginTop: "10px" }}>
                      {centerCardMarkets.map((market, index) => {
                        const winner = centerCardWinners.includes(market);
                        return (
                          <div
                            key={index}
                            style={{
                              textAlign: "center",
                              marginBottom: "18px"
                            }}
                          >
                            <div
                              style={{
                                fontSize: "22px",
                                fontWeight: "700"
                              }}
                            >
                              {market}
                            </div>
                            <div
                              style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: "#000",
                                textTransform: "uppercase"
                              }}
                            >
                              {winner ? "WINNER" : "LOSER"}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};

export default PopUpCentercardResults;

